import React from 'react';

const ParameterIcon = ({ title, width, height, healthPlus = false, basePath = '/assets/icons/svg' }) => {
  let filename = '';
  switch (title) {
    case 'Hälsa':
      filename = !healthPlus ? 'Halsa-plus.svg' : 'Halsa.svg';
      break;
    case 'Antibiotikaresistens':
      filename = 'Antibiotikaresistens.svg';
      break;
    case 'Klimat':
      filename = 'Klimat-gron.svg';
      break;
    case 'Vatten':
      filename = 'Vatten.svg';
      break;
    case 'Djurvälfärd':
      filename = 'Djurvalfard.svg';
      break;
    case 'Arbetsförhållanden':
      filename = 'Arbetsforhallanden.svg';
      break;
    case 'Miljö':
      filename = 'Miljo.svg';
      break;
    case 'Biologisk mångfald':
      filename = 'Biologisk-mangfald.svg';
      break;
    case 'Transport':
      filename = 'Transport.svg';
      break;
    case 'Transparens':
      filename = 'Visa.svg';
      break;
    case 'Hälsa ': // note trailing space in server code
      filename = 'Halsa.svg';
      break;
    case 'Landanvändning':
      filename = 'Landandvandning.svg'; // matches server spelling
      break;
    case 'Bekämpningsmedel':
      filename = 'Bekampningsmedel.svg';
      break;
    case 'Övergödning':
      filename = 'Overgodning.svg';
      break;
    case 'Social rättvisa':
      filename = 'Social-rattvisa.svg';
      break;
    case 'Rättvisa':
      filename = 'Rattvisa.svg';
      break;
    case 'Jämlikhet':
      filename = 'Jamstalldhet.svg';
      break;
    case 'Barnarbete':
      filename = 'Barnarbete.svg';
      break;
    case 'Lokalbefolkning':
      filename = 'Lokalbefolkning.svg';
      break;
    default:
      return null;
  }

  const src = `${basePath}/${filename}`;
  return (
    <img
      src={src}
      alt={title}
      width={width}
      height={height}
      style={{ width, height, objectFit: 'contain' }}
      onError={(e) => {
        // Hide broken icon to avoid layout shift
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default ParameterIcon;


